<template>
    <section>
        <div class="main">
            <div class="img"
                :style="{backgroundImage: `url(${aiImg})`}"
            />
            <div class="content">
                <h3>{{ $t('homepage.ai.title') }}<a href="#tip" v-anchor class="tip-link"><sup>1</sup></a></h3>
                <ul>
                    <li v-for="feature in features" :key="feature.title">
                        <div class="title" @click="feature.expanded = !feature.expanded">
                            <h4>{{ feature.title }}</h4>
                            <button class="button_clear expand_btn">
                                <i :class="feature.expanded? 'icon-co_up': 'icon-co_down'"/>
                            </button>
                        </div>
                        <div v-show="feature.expanded" class="expanded-content">
                            <p>{{ feature.description }}</p>
                        </div>

                    </li>
                </ul>
            </div>
        </div>
    </section>
</template>

<script lang="ts">
import Vue from 'vue';
import AiImg from 'IMAGE/homepage/ai.jpg';

interface IFeature {
    title: string;
    description: string;
    expanded: boolean;
}

export default Vue.extend({
    data() {

        return {
            aiImg: AiImg,
            features: ( this.$t( 'homepage.ai.features' ) as unknown as IFeature[] ).map(( feature, index ) => ({
                ...feature,
                expanded: index === 0
            }))
        };

    },
});
</script>

<style lang="less" scoped>
section{
    background-color: @bg_02;
    padding: 77px 0;
    .mobile({
        padding: 0;
    });
    .main{
        max-width: 1200px;
        margin: 0 auto;
        display: flex;
        @border-radius: 16px;
        .mobile({
            flex-direction: column-reverse;
            .mobileMaxWidth();
            padding: 32px 20px;
        });
        & > div{
            min-height: 600px;
            background-color: @bg_01;
            min-width: 0;
            box-sizing: border-box;
            flex: 1;
            padding: 58px 60px;
            .mobile({
                padding: 0;
                padding-top: 32px;
                min-height: unset;
                background-color: @bg_02;
            });
            &:first-child{
                border-top-left-radius: @border-radius;
                border-bottom-left-radius: @border-radius;
            }
            &:last-child{
                border-top-right-radius: @border-radius;
                border-bottom-right-radius: @border-radius;
            }
        }
        .img{
            background-size: auto 100%;
            background-repeat: no-repeat;
            .mobile({
                width: 100%;
                aspect-ratio: 1;
                border-radius: @border-radius;
                background-position: center;
            });
        }
        .content{
            h3{
                font-size: 28px;
                line-height: 42px;
                font-weight: 600;
                margin-bottom: 24px;
                text-align: left;
                .mobile({
                    text-align: center;
                });
            }
            ul{
                background-color: @bg_02;
                border-radius: @border-radius-level-1;
                li{
                    padding: 20px;
                    &:not(:last-child){
                        border-bottom: 1px solid @bg_01;
                    }
                    .mobile({
                        padding: 12px;
                    });
                    .title{
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        cursor: pointer;
                        h4{
                            font-size: 20px;
                            font-weight: 600;
                            line-height: 30px;
                        }
                        .expand_btn{
                            border-radius: 100%;
                            border: 1px solid @font_primary;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            font-size: 20px;
                        }
                    }
                    .expanded-content{
                        font-size: 14px;
                        font-weight: 500;
                        line-height: 21px;
                        color: @font_secondary;
                        margin-top: 12px;
                        text-align: left;
                    }
                }
            }
        }

    }
}
</style>
